import * as JQuery from 'jquery';

const $ = JQuery.default;

export const alphabetScroll = () => {
    const innerAlphabetStickyTop = document.querySelector(
        '.inner-alphabet-sticky-top'
    );
    const alphabetSticky = document.querySelector('.alphabet-filter-sticky');
    const stickyButtons = document.querySelectorAll('.alphabet-filter-btn');
    const filterButtons = document.querySelectorAll('.filter-btn');
    const sectionIdentifier = document.querySelectorAll(
        '.alphabet-scroll-holder'
    );

    if (!sectionIdentifier || sectionIdentifier.length === 0) {
        return;
    }

    const linkHolder = document.querySelectorAll('.alphabet-list-holder');
    // const htmlDocument = document.querySelector('html');

    function doScrollIntoView(e) {
        const filterButton = e.target;

        if (filterButton) {
            innerAlphabetStickyTop.classList.remove('sticky-hidden-top');

            filterButton.scrollIntoView({
                behavior: 'instant',
                block: 'center',
                inline: 'nearest',
            });
        }
    }

    if (alphabetSticky) {
        for (let i = 0; i < sectionIdentifier.length; i += 1) {
            if (!linkHolder[i].hasChildNodes()) {
                sectionIdentifier[i].classList.add('hidden-alphabet-section');
                stickyButtons[i].classList.add('alphabet-filter-btn-hidden');
            }
        }
    }

    filterButtons.forEach((x) => x.addEventListener('focus', doScrollIntoView));

    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();

            const href = document.querySelector(anchor.getAttribute('href'));

            if (href) {
                href.scrollIntoView({
                    behavior: 'smooth',
                });
                setTimeout(() => {
                    document
                        .querySelector('html')
                        .setAttribute('data-scrolldir', 'down');
                }, 1000);

                // Set the focus to the first link in this letter group.
                $('div#' + href.id)
                    .find(':nth-of-type(2)')
                    .find(':first')
                    .find(':first')
                    .focus();
            }
        });
    });

    ((document, history, location) => {
        const HISTORY_SUPPORT = !!(history && history.pushState);

        const anchorScrolls = {
            ANCHOR_REGEX: /^#[^ ]+$/,
            OFFSET_HEIGHT_PX: 80,

            /**
             * Establish events, and fix initial scroll position if a hash is provided.
             */
            init() {
                this.scrollToCurrent();
                $(window).on('hashchange', $.proxy(this, 'scrollToCurrent'));
                $('body').on('click', 'a', $.proxy(this, 'delegateAnchors'));
            },

            /**
             * Return the offset amount to deduct from the normal scroll position.
             * Modify as appropriate to allow for dynamic calculations
             */
            getFixedOffset() {
                return this.OFFSET_HEIGHT_PX;
            },

            /**
             * If the provided href is an anchor which resolves to an element on the
             * page, scroll to it.
             * @param  {String} href
             * @param {Boolean} pushToHistory
             * @return {Boolean} - Was the href an anchor.
             */
            scrollIfAnchor(href, pushToHistory) {
                let anchorOffset;

                if (!this.ANCHOR_REGEX.test(href)) {
                    return false;
                }

                const match = document.getElementById(href.slice(1));

                if (match) {
                    anchorOffset =
                        $(match).offset().top - this.getFixedOffset();
                    $('html, body').animate({ scrollTop: anchorOffset });

                    // Add the state to history as-per normal anchor links
                    if (HISTORY_SUPPORT && pushToHistory) {
                        history.pushState(
                            {},
                            document.title,
                            location.pathname + window.location.search + href
                        );
                    }
                }

                return !!match;
            },

            /**
             * Attempt to scroll to the current location's hash.
             */
            scrollToCurrent(e) {
                if (this.scrollIfAnchor(window.location.hash) && e) {
                    e.preventDefault();
                }
            },

            /**
             * If the click event's target was an anchor, fix the scroll position.
             */
            delegateAnchors(e) {
                const elem = e.target;

                if (this.scrollIfAnchor(elem.getAttribute('href'), true)) {
                    e.preventDefault();
                }
            },
        };

        $(document).ready($.proxy(anchorScrolls, 'init'));
    })(window.document, window.history, window.location);
};
